import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type Props = {
  label: string;
  sub?: string;
  variant?: 'teal' | 'plum' | 'gold';
  className?: string;
};
const variants: Record<string, string> = {
  teal: 'bg-teal text-white hover:bg-teal-light shadow-[0_10px_0_-2px_rgba(9,90,90,0.55)]',
  plum: 'bg-plum text-white hover:bg-plum-light shadow-[0_10px_0_-2px_rgba(45,17,70,0.55)]',
  gold: 'bg-gold text-plum-deep hover:bg-[#dda93a] shadow-[0_10px_0_-2px_rgba(140,100,20,0.5)]'
};
export function CTAButton({
  label,
  sub,
  variant = 'teal',
  className = ''
}: Props) {
  return <div className={`w-full ${className}`} data-id="element-28" data-mp="33nur82brmai7">
      <a href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-2 rounded-2xl px-5 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-[0.02em] transition-[transform,background-color] duration-200 ease-out hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-plum active:translate-y-0.5 sm:text-lg sm:py-5 ${variants[variant]}`} data-id="element-29" data-mp="2yq2yx777kmdh">
        <span className="text-balance" data-id="element-30" data-mp="1dartr01uyzsx">{label}</span>
        <ArrowRightIcon className="hidden h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1 sm:block" aria-hidden="true" data-id="element-31" data-mp="1i9bh94w3ojne" />
      </a>
      {sub ? <p className="mt-3 text-center text-[13px] font-medium text-ink/60 sm:text-sm" data-id="element-32" data-mp="1s6pnkbob7s1z">{sub}</p> : null}
    </div>;
}